@if (isQuickLoadOpen && (isViewingSharedProject() | async) === false) {
  <gl-add-load
    [isQuick]="true"
    (closeAddLoad)="closeQuickAddLoads()"
  ></gl-add-load>
}
@if (isQuickLoadingSpaceOpen && (isViewingSharedProject() | async) === false) {
  <gl-add-loading-space
    [isQuick]="true"
    (closeAddLoadingSpace)="closeQuickAddLoadingSpaces()"
  ></gl-add-loading-space>
}
@if ((isViewingSharedProject() | async) === false) {
  <div
    [class.disable]="project.workSpaces[0]?.stops?.length > 0"
    class="menuItem"
    >
    <gl-menu-item
      #addLoadingSpacesOpener
      (click)="openAddLoadingSpaces()"
      [active]="isAddLoadingSpacesActive()"
      class="clickable loadingSpace"
      data-ctx="button-open-loadingSpaces"
      >
      <div class="label">{{ 'loading_space' | translate }}</div>
      <gl-icon [name]="'add-1'" class="addIcon" data-ctx="button-add-1"></gl-icon>
    </gl-menu-item>
    <div class="quickLoadingSpace" (click)="toggleQuickLoadingSpace()" data-ctx="button-quickload-loadingSpace">
      <gl-icon [name]="'note'" class="noteIcon"></gl-icon>
    </div>
  </div>
}
@if (isAddLoadingSpacesActive()) {
  <gl-add-loading-space
    (glMousedownOutside)="closeAddLoadingSpaces()"
    (submitted)="closeAddLoadingSpaces()"
    [elementToIgnore]="openAddLoadingSpacesEl"
    (closeAddLoadingSpace)="closeAddLoadingSpaces()"
  ></gl-add-loading-space>
}
@if ((isViewingSharedProject() | async) === false) {
  <div class="menuItem">
    <gl-menu-item
      #addLoadOpener
      (click)="openAddLoads()"
      [active]="isAddLoadsActive()"
      class="clickable load"
      data-ctx="button-open-add-loads"
      >
      <div class="label">{{ 'loading' | translate }}</div>
      <gl-icon [name]="'add-1'" class="addIcon" data-ctx="button-add+1"></gl-icon>
    </gl-menu-item>
    <div class="quickLoad" (click)="toggleQuickLoad()" data-ctx="button-quickload">
      <gl-icon [name]="'note'" class="noteIcon"></gl-icon>
    </div>
  </div>
}
@if (isAddLoadsActive()) {
  <gl-add-load
    (glMousedownOutside)="closeAddLoads()"
    [elementToIgnore]="openAddLoadEl"
    (closeAddLoad)="closeAddLoads()"
  ></gl-add-load>
}

@if (isViewingSharedProject() | async) {
  <gl-open-shared-project></gl-open-shared-project>
}

<gl-menu-item class="loads-list">
  <gl-loads-list></gl-loads-list>
</gl-menu-item>
